import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
//import { CALL_THRESHOLDS, ATTAINMENT_PCT_THRESHOLDS } from "./constants";

/**
 * Merge Tailwind classes with clsx support.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Format number with locale-specific thousands separator.
 */
export function formatNumber(num: number): string {
  return new Intl.NumberFormat("en-US").format(num);
}

/**
 * Format number as percentage with one decimal place.
 */
export function formatPercent(num: number): string {
  return `${num.toFixed(1)}%`;
}

/**
 * Format ISO date string to readable format.
 */
export function formatDateTime(dateStr: string): string {
  const date = new Date(dateStr);
  return date.toLocaleString("en-US", {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
}

export type AttainmentStatus = "success" | "warning" | "danger";

/**
 * Determine status based on calls logged count.
 */
// export function getAttainmentStatus(logged: number): AttainmentStatus {
//   if (logged >= CALL_THRESHOLDS.SUCCESS) return "success";
//   if (logged >= CALL_THRESHOLDS.WARNING) return "warning";
//   return "danger";
// }

// /**
//  * Determine status based on attainment percentage.
//  */
// export function getAttainmentStatusFromPct(pct: number): AttainmentStatus {
//   if (pct >= ATTAINMENT_PCT_THRESHOLDS.SUCCESS) return "success";
//   if (pct >= ATTAINMENT_PCT_THRESHOLDS.WARNING) return "warning";
//   return "danger";
// }